import React from 'react'
import { Control, ControllerRenderProps, FieldValues } from 'react-hook-form'

import { DatePickerModeEnum } from '../../../../forms/date-picker/date-picker.enum'
import { DatePickerCalendar } from '../../../../forms/date-picker/DatePickerCalendar'
import { IDatesCalendarProps } from '../../../../organisms/dates-calendar/dates-calendar'

export type DatesPickerProps = {
  field: ControllerRenderProps<FieldValues, string>
  control: Control<any, any>
  dateCalendarProps: IDatesCalendarProps
  onValid: () => void
}

export const DatesPicker = ({
  field,
  control,
  dateCalendarProps,
  onValid,
}: DatesPickerProps) => {
  return (
    <DatePickerCalendar
      field={field}
      control={control}
      dateCalendarProps={dateCalendarProps}
      isMobile
      revampPicker
      mode={DatePickerModeEnum.HOUSE_SEARCH}
      onValid={onValid}
    />
  )
}
